import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@core/security/services/auth.service';
import { AppState } from '@core/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import * as accesosActions from '../actions/accesos.actions';
import * as menuActions from '../actions/menu.actions';
import { currentAccesos } from '../selectors/accesos.selectors';

@Injectable()
export class MenuEffects {
	constructor(private actions$: Actions, private store: Store<AppState>, private auth: AuthService, private router: Router) {}

	cargarMenu$ = createEffect(() =>
		this.actions$.pipe(
			ofType(menuActions.cargarMenu),
			withLatestFrom(this.store.pipe(select(currentAccesos))),
			mergeMap(([action, formularioAcciones]) =>
				this.auth.findAllByCodigoSistemaAndIdFormularioList(formularioAcciones.map((formA: any) => formA.idFormulario)).pipe(
					map((formularioAcciones) => {
						this.store.dispatch(accesosActions.validarAccesoFormulario());
						//artificio para no mostrar el formulario tablero principal en el menu de navegacio
						formularioAcciones = formularioAcciones.filter((formA: any) => formA.codigo !== 'TPR');
						return menuActions.cargarMenuSuccess({ sciMenu: formularioAcciones });
					}),
					catchError((err) => {
						this.store.dispatch(menuActions.cargarMenuError({ payload: err }));
						return of(accesosActions.validarAccesoFormulario());
					})
				)
			)
		)
	);

	// cargarAccesosSucces$ = createEffect(
	//     () => this.actions$.pipe(
	//         ofType( accesosActions.cargarAccesosSuccess ),
	//         tap(
	//             (action) => this.store.dispatch(menuActions.cargarMenu()),
	//         )
	//     )
	// , {dispatch: false});
}
